export function subscribe(path: string, onMessage: (data: any) => void) {
  const url = (import.meta.env.VITE_BFF_BASE_URL || '') + path;
  const es = new EventSource(url, { withCredentials: true } as any);
  es.onmessage = (e) => {
    try { onMessage(JSON.parse(e.data)); }
    catch { onMessage(e.data); }
  };
  return () => es.close();
}


